import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  icon: PropTypes.node,
  children: PropTypes.node,
};

const CardElementPlaceholder = ({ icon, children }) => {
  return (
    <div className="card-element-placeholder">
      {icon && <span className="card-element-placeholder-icon">{icon}</span>}
      {children && (
        <div className="card-element-placeholder-children">{children}</div>
      )}
    </div>
  );
};

CardElementPlaceholder.propTypes = propTypes;

export default CardElementPlaceholder;
